import Page from "webPage/Page";
import Ajax from "base/Ajax";
import ValueHelper from "base/ValueHelper";
import PromiseHelper from "base/PromiseHelper";

Page.register('/resources', () => {
    let currentPage = 1;
    let request;
    let filters = $(".js-filter-form").serializeJSON();

    $("body").on("click", ".js-resource-toggle", function () {
        if ($(window).width() >= 960) return false;

        $(this).parents(".resource").toggleClass("resource--active");

        return false;
    }).on("click", ".js-load-more", function () {
        let $btn = $(this);
        if ($btn.is(".btn--loading")) return false;
        $btn.addClass("btn--loading");

        loadMore();

        return false;
    }).on("click", ".js-filter-toggle", () => {
        $(".js-filter").toggleClass("filter--active");
        return false;
    }).on("change", ".js-resource-filter", function () {
        updateFilters();

    }).on("submit", ".js-filter-form", function () {
        updateFilters();

        return false;
    }).on("click", ".js-clear-filter", () => {
        $(".js-resource-filter").prop("checked", false);
        $(".js-filter").removeClass("filter--active");
        updateFilters();
    }).on('click', function (e) {
        let $target = $(e.target);
        if ($(".js-filter.filter--active").length > 0 && !$target.is(".js-filter") && $target.parents('.js-filter').length === 0 && !$target.is(".js-filter-toggle") && $target.parents(".js-filter-toggle").length === 0) {
            $(".js-filter").removeClass("filter--active");
        }
    });

    function updateFilters() {
        filters = $(".js-filter-form").serializeJSON();
        currentPage = 0;
        loadMore(true);
    }


    function loadMore(fullLoading = false) {
        let $list = $(".js-resources-list");
        if (fullLoading) {
            $list.addClass("resources__list--loading");
        }

        $(".js-load-more").addClass("btn--loading");
        if (request) request.abort();
        let page = currentPage + 1;

        request = Ajax.get("content", "f98a8b30c71c0d7e/posts/search", $.extend({}, filters, {
            limit: 10,
            page: page,
            sort: {by: "order", direction: 'ASC'}
        }), Ajax.WEBSITE);
        return PromiseHelper.delayed_promise(request, 700).then((data) => {
            currentPage = page;


            if (fullLoading) {
                $list.html("");
            }

            data.results.forEach((post) => {

                if (post.activeRevision.values.file.length === 0) return;
                let values = post.activeRevision.values;

                let file = values.file && values.file.length > 0 ? values.file[0] : null;

                let svg_ext = ['doc', 'jpeg', 'pdf', 'png', 'ppt', 'txt', 'xls'].indexOf(file ? file.extension : '') === -1 ? 'file' : 'file-' + file.extension;

                let category = values.category.length > 0 ? values.category[0] : null;

                $list.append(
                    eotwJSXFactory('div', {class: "resource"}, [
                        eotwJSXFactory('div', {class: "resource__row js-resource-toggle"}, [
                            eotwJSXFactory('div', {class: "resource__file"}, [
                                eotwJSXFactory('span', {class: "resource__file-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#' + svg_ext + '"></use></svg>'),
                                eotwJSXFactory('span', {class: "resource__file-amount"}, [ValueHelper.format_bytes(file ? file.size : 0, 0, '')])
                            ]),

                            eotwJSXFactory('h5', {'data-field': "title"}, [values.title ? values.title : (file ? file.name : '')]),
                            eotwJSXFactory('span', {class: "resource__icon"})
                        ]),

                        eotwJSXFactory('div', {class: "resource__row-wrap"}, [
                            eotwJSXFactory('div', {class: "resource__row resource__row--info"}, [
                                eotwJSXFactory('div', {'data-field': "snippet", class: "resource__text", unsafeHtml: values.snippet}),
                                eotwJSXFactory('div', {class: "resource__category"}, [
                                    category !== null ? eotwJSXFactory('p', null, [category.name]) : undefined
                                ]),
                                eotwJSXFactory('div', {class: "resource__dl"}, [
                                    eotwJSXFactory('a', {href: file.url, class: "btn btn--download"}, ["Download ", eotwJSXFactory('span', {class: "btn__icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#download-icon"></use></svg>')])
                                ])
                            ])
                        ])
                    ])
                )
            });
            $(".js-load-more").removeClass("btn--loading");
            $list.removeClass("resources__list--loading");
            if (currentPage >= data.pages.max) {
                $(".js-buttons-wrap").hide();
            } else {
                $(".js-buttons-wrap").show();
            }
        }).catch((e) => {
            $(".js-load-more").removeClass("btn--loading");
            $list.removeClass("resources__list--loading");

            console.log(e);
            alert(e.message);
        });
    }

});
